import React from "react";
import { useAuth } from "@/context/AuthContext";

// Verification edge — a colored bar across the TOP EDGE of a card / profile header.
// GREEN = identity verified (a real person). EMERALD = dealer verified (a licensed business).
// Both -> split 50/50 (id-green left, dealer-emerald right). One -> full width. Neither -> nothing.
//
// The split is TWO ADJACENT flex children at flex:1 each — NEVER a CSS gradient. A gradient
// produces a muddy seam at some zooms/displays; this is a hard edge with no blend.
// NOTE: this affordance is reserved for verification. Do NOT reuse a colored top edge for
// boosted/featured listings — use a corner flag or outer glow instead so the two don't collide.
// Dealer is EMERALD (not blue) — #1f6ba8 is reserved for EXTERNAL·BUSINESS conversations.
const GREEN = "#4e8a1f";
const DEALER = "#1f7a4d";

export function VerificationEdge({ identityVerified, dealerVerified, height = 3, className = "" }) {
  // Dealer edge stays dark until the business category opens.
  const { businessFeaturesEnabled } = useAuth();
  dealerVerified = dealerVerified && businessFeaturesEnabled;
  if (!identityVerified && !dealerVerified) return null;
  return (
    <div
      className={`flex w-full overflow-hidden ${className}`}
      style={{ height }}
      aria-hidden="true"
      data-testid="verification-edge"
      data-state={identityVerified && dealerVerified ? "both" : identityVerified ? "id" : "dealer"}
    >
      {identityVerified && <div style={{ flex: 1, backgroundColor: GREEN }} data-testid="verification-edge-id" />}
      {dealerVerified && <div style={{ flex: 1, backgroundColor: DEALER }} data-testid="verification-edge-dealer" />}
    </div>
  );
}

export default VerificationEdge;
